export default "__VITE_ASSET__XkR96LH___"